module.exports = __webpack_public_path__ + "img/cotoclub2.4905cf8b.png";